// extracted by mini-css-extract-plugin
export default {"sampleComparisonTable":"nkLA66","sampleComparisonTable__measurementCell":"OEesRb","linkableText":"i_lpiK"};